module.exports = __webpack_public_path__ + "static/media/credit-score.d9c84cc0.svg";